import { render, staticRenderFns } from "./SwitchRoles.vue?vue&type=template&id=0280be4e"
import script from "./SwitchRoles.vue?vue&type=script&lang=js"
export * from "./SwitchRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports